import { gql, useMutation } from '@apollo/client'

const mutation = gql`
   mutation updateNote($id: ID!, $input: ExperimentalUpdateNoteInput!) {
      experimentalUpdateNote(id: $id, input: $input) {
         id
         locked
         lockedByCurrentConnection
         pinned
      }
   }
`

const useUpdateNote = (mutationHookOptions) => {
   const [updateNote, { called, client, data, error, loading }] =
      useMutation(mutation, mutationHookOptions)

   const wrappedMutationFn = (filter, input, mutationFnOptions) => updateNote({
      variables: { ...filter, input },
      ...mutationFnOptions
   })

   return {
      updateNote: wrappedMutationFn,
      called,
      client,
      error,
      mutating: loading,
      result: data
   }
}

export default useUpdateNote
